import React from 'react';

const TermsAndConditions = () => (
  <div>
    <p>These are the sample terms and conditions.</p>
  </div>
);

export default TermsAndConditions; 